import React, { useEffect, useRef, useState } from "react"
import "./Nav.css"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { getUser } from "../app/features/userSlice"
import { Drawer } from "@mui/material"
import DehazeIcon from "@mui/icons-material/Dehaze"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

import Sumary from "./Sumary"

const getInitials = (name) => {
  if (!name) return "?"
  const parts = name.trim().split(" ")
  return parts.length > 1
    ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    : parts[0][0].toUpperCase()
}

function Nav({ sections = [], scrollFunc = function () {} }) {
  const [openSumary, setOpenSumary] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const searchInputRef = useRef()
  const searchWrapRef = useRef()

  const navigate = useNavigate()
  const user = useSelector(getUser)

  const toggleDrawer = (newOpen) => () => setOpenSumary(newOpen)

  const expandSearch = () => {
    setSearchOpen(true)
    requestAnimationFrame(() => searchInputRef.current?.focus())
  }

  const collapseSearch = () => {
    setSearchOpen(false)
    setSearchQuery("")
  }

  const submitSearch = () => {
    if (searchQuery.trim().length > 0) navigate(`/search/${searchQuery.trim()}`)
  }

  useEffect(() => {
    if (!searchOpen) return
    const handler = (e) => {
      if (searchWrapRef.current && !searchWrapRef.current.contains(e.target)) {
        setSearchOpen(false)
        setSearchQuery("")
      }
    }
    document.addEventListener("mousedown", handler)
    return () => document.removeEventListener("mousedown", handler)
  }, [searchOpen])

  return (
    <div className="nav">
      <div className="nav__contents">
        <div className="nav__left">
          {sections.length > 0 && (
            <DehazeIcon
              className="nav__dehaze"
              onClick={toggleDrawer(true)}
            />
          )}
          <img
            onClick={() => navigate("/")}
            className="nav__logo"
            src={process.env.PUBLIC_URL + "/Selo_5.svg"}
            alt="Cosmo"
          />
        </div>

        <img
          className="nav__center-logo"
          src={process.env.PUBLIC_URL + "/Primário_5.svg"}
          alt="Cosmo"
          onClick={() => navigate("/")}
        />

        <div className="nav__right">
          <div
            ref={searchWrapRef}
            className={`nav__search-wrap${searchOpen ? " nav__search-wrap--open" : ""}`}
          >
            <input
              ref={searchInputRef}
              className="nav__search-input"
              type="text"
              placeholder="Pesquisar…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") submitSearch()
                if (e.key === "Escape") collapseSearch()
              }}
              tabIndex={searchOpen ? 0 : -1}
              aria-hidden={!searchOpen}
            />
            <button
              className="nav__search-btn"
              onClick={searchOpen ? submitSearch : expandSearch}
              aria-label="Pesquisar"
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          <div className="nav__avatar" onClick={() => navigate("/profile")}>
            {getInitials(user?.name)}
          </div>
        </div>
      </div>

      <Drawer open={openSumary} onClose={toggleDrawer(false)}>
        <Sumary
          sections={sections}
          toggleDrawer={toggleDrawer}
          scrollFunc={scrollFunc}
        />
      </Drawer>
    </div>
  )
}

export default Nav
